import { mockHeroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 pointer-events-none"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">日更同步</span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">海量资源</span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">全免费</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-5">
              虫虫漫画 - 你的免费漫画天堂
            </h1>

            <p className="text-lg md:text-xl text-foreground-700 mb-4 font-heading">
              好看的漫画都在这里
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              虫虫漫画大全汇集全网热门韩漫、日漫与国漫资源，每日更新海量漫画内容。支持下拉式在线阅读，追更收藏一站式体验。无论你是韩漫迷、日漫粉还是国漫爱好者，这里都有你想要的精彩漫画内容，永久免费畅享。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8 flex-wrap">
              {mockHeroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer no-underline whitespace-nowrap w-full sm:w-auto text-center"
              >
                开始阅读
              </a>
              <a
                href="#ranking"
                className="px-8 py-3 border border-background-300 text-foreground-700 rounded-md font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap w-full sm:w-auto text-center"
              >
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20manga%20reading%20illustration%2C%20cozy%20warm%20atmosphere%2C%20person%20reading%20colorful%20manga%20on%20tablet%2C%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20soft%20golden%20and%20amber%20lighting%2C%20modern%20editorial%20illustration%20style%2C%20clean%20composition%2C%20warm%20gradient%20background&width=1200&height=900&seq=manga-hero-main&orientation=landscape"
                alt="虫虫漫画在线阅读 - 漫画阅读场景插图"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}